import React from 'react';
import { useIntl } from 'umi';
import { useMount } from 'ahooks';
import Report from '@intelligence/pages/InsightsCenterLibrary/report';
import { getReportBySystemTypeApi } from '@intelligence/services/reportService';
import { buriedPointPage, pointInter } from '@home/utils/buriedPoint';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { pageReportTypeConfig } from '@intelligence/pages/InsightsReport/_config';

export interface IInsightsCenterLibraryTab {
  id: string;
  label: string;
  pagePoint: pointInter;
}

const InsightsCenterLibrary = () => {
  const { formatMessage } = useIntl();

  const tabs: IInsightsCenterLibraryTab[] = [
    {
      id: 'all',
      label: formatMessage({ id: 'dbi_all' }),
      pagePoint: dbiPageLogMes.insightsCenterLibrary,
    },
    {
      id: 'Fundamental Study',
      label: formatMessage({ id: 'dbi_insights_center_library_fundamental_study' }),
      pagePoint: dbiPageLogMes.insightsCenterLibraryFundamentalStudy,
    },
    {
      id: 'GRIP Report',
      label: formatMessage({ id: 'dbi_insights_center_library_grip' }),
      pagePoint: dbiPageLogMes.insightsCenterLibraryGRIP,
    },
    // {
    //   id: 'Ad-Hoc Research',
    //   label: formatMessage({ id: 'dbi_insights_center_library_ad_hoc_research' }),
    //   pagePoint: dbiPageLogMes.insightsCenterLibraryAdHocResearch,
    // },
    {
      id: 'Regional Monthly Report',
      label: formatMessage({ id: 'dbi_insights_center_library_regional_monthly_report' }),
      pagePoint: dbiPageLogMes.insightsCenterLibraryRegionalMonthlyReport,
    },
  ];

  useMount(() => {
    buriedPointPage(dbiPageLogMes.insightsCenterLibrary);
  });

  return (
    // @ts-ignore
    <Report
      title={formatMessage({ id: 'dbi_insights_center_library' })}
      subTitle={formatMessage({ id: 'dbi_insights_center_library_intro' })}
      tabs={tabs}
      reportType="insightsCenterLibrary"
      // searchType={'insightsCenterLibrarySearch'}
      pageLogMes={dbiPageLogMes.insightsCenterLibrary}
      getReportFun={() => getReportBySystemTypeApi('intelligence_iic')}
      reportTypeConfig={pageReportTypeConfig.insightsCenterLibrary}
    />
  );
};

export default InsightsCenterLibrary;
